import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';
import { changeCity } from '@r1-frontend/entities/City/helpers/changeCity';
import { closeCitySelect } from '@r1-frontend/entities/Layout/CitySelectContainer/store/actionCreators';
import { TState } from '@r1-frontend/entities/Layout/CitySelectContainer/store/reducer';
import { setIsAuth } from '@r1-frontend/entities/stores/auth/actionCreators';
import selectProviderId from '@r1-frontend/entities/stores/city/selectors/selectProviderId';

const saveCity = (selectedCity?: ICitySatellite) => {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState): Promise<void> => {
        const state = getState();
        const { auth: { isAuth } } = state;
        const providerId = selectProviderId(state);

        if (selectedCity) {
            const { provider_id, has_sso } = selectedCity;
            if (provider_id !== providerId) {
                dispatch(setIsAuth(false));

                changeCity(provider_id, window.location.pathname, isAuth && !has_sso);
            }
        }

        dispatch(closeCitySelect());
    };
};

export default saveCity;
